import {useEffect, useRef, useState} from "react";
import ImmoCardHome from "./ImmoCardHome";
import IconArrowDown from "../../data/Icons/leon-inmobiliaria-icons-arrow-1-down.svg";
import {useRouter} from "next/router";
import {Filter} from "../../data/Filter/Filter.config";
import {ObjectInterfaceWithCity} from "../../interfaces/ObjectInterface";
import {useTranslation} from "next-i18next";
import Button from "./Button";

export interface ImmobilieKaufenHomeInterface extends ObjectInterfaceWithCity {
	shouldBeVisible: boolean;
	isVisible: boolean;
}

export interface ImmobilieKaufenHomePropsInterface {
	objects: ImmobilieKaufenHomeInterface[];
}

export default function ImmobilieKaufenHome(props: ImmobilieKaufenHomePropsInterface) {
	const {t} = useTranslation();
	const router = useRouter();

	const containerRef = useRef<HTMLDivElement>(null);

	const [offers, setOffers] = useState<ImmobilieKaufenHomeInterface[]>([]);
	useEffect(() => {
		if (props.objects && props.objects) {
			// duplicate the first object in objetcs
			// const firstObject = props.objects[0];
			// const lastObject = props.objects[props.objects.length - 1];
			// const newObjects = [
			//   ...props.objects,
			//   firstObject,
			//   firstObject,
			//   firstObject,
			//   firstObject,
			//   firstObject,
			//   firstObject,
			//   firstObject,
			//   lastObject,
			// ];
			// setOffers(newObjects);
			setOffers(props.objects);
		}
	}, [props.objects, router.locale]);

	const [prevDisabled, setPrevDisabled] = useState(true);
	const [nextDisabled, setNextDisabled] = useState(false);
	if (!props.objects) return <></>;

	function updateButtonStates() {
		setTimeout(() => {
			setPrevDisabled(
				!containerRef.current || containerRef.current.scrollLeft <= 0
			);
			if (containerRef.current) {
				setNextDisabled(
					containerRef.current.scrollLeft + containerRef.current.clientWidth >=
					containerRef.current.scrollWidth
				);
			}
		}, 1000);
	}

	function handleNext(offers: ImmobilieKaufenHomeInterface[]) {
		if (containerRef.current) {
			containerRef.current.scroll({
				left:
					containerRef.current.scrollLeft + containerRef.current.clientWidth,
				behavior: "smooth",
			});
		}
		updateButtonStates();
	}

	function handlePrevious(offers: ImmobilieKaufenHomeInterface[]) {
		if (containerRef.current) {
			containerRef.current.scroll({
				left:
					containerRef.current.scrollLeft - containerRef.current.clientWidth,
				behavior: "smooth",
			});
		}
		updateButtonStates();
	}

	return (
		<div className="px-0 lg:px-6 xl:px-0">
			<div className="flex w-full items-end mb-6 justify-between lg:justify-between pr-4 sm:pr-0">
				<div className="hidden lg:block">
					<Button
						className="hidden lg:block text-[16px]"
						text={t("common.saleLink")}
						transparent={true}
						border={false}
						textColor={"text-black"}
						href={"/verkauf"}
						textTransform="underline"
						padding={"p-0"}
					/>
				</div>
				<h2 className="text-[24px] lg:text-[40px] xl:text-[54px] font-light">{t("navigation.sale")}</h2>
				<div className="flex gap-2 sm:gap-4 text-white">
					<button
						className={`${
							prevDisabled
								? "bg-gradient-to-b from-[#b6aa9b] to-[#857a6d] hover:bg-leo-dark-brown hover:from-transparent hover:to-transparent transition-all duration-300"
								: "bg-gradient-to-b from-[#b6aa9b] to-[#857a6d] hover:bg-leo-dark-brown hover:from-transparent hover:to-transparent transition-all duration-300"
						} w-8 h-8 sm:w-11 sm:h-11 flex justify-center items-center rounded-[10px] `}
						disabled={prevDisabled}
						onClick={() => handlePrevious(offers)}
					>
						<IconArrowDown className="rotate-90 w-5 sm:w-8"/>
					</button>
					<button
						className={`${
							nextDisabled
								? "bg-gradient-to-b from-[#b6aa9b] to-[#857a6d] hover:bg-leo-dark-brown hover:from-transparent hover:to-transparent transition-all duration-300"
								: "bg-gradient-to-b from-[#b6aa9b] to-[#857a6d] hover:bg-leo-dark-brown hover:from-transparent hover:to-transparent transition-all duration-300"
						} w-8 h-8 sm:w-11 sm:h-11 flex justify-center items-center rounded-[10px] `}
						disabled={nextDisabled}
						onClick={() => handleNext(offers)}
					>
						<IconArrowDown className="-rotate-90 w-5 sm:w-8"/>
					</button>
				</div>
			</div>
			<div
				className={`flex w-full sm:justify-start gap-6 lg:gap-7 overflow-x-scroll touch-pan-y touch-pan-x snap-x md:snap-none no-scrollbar`}
				ref={containerRef}
			>
				{offers.map((offer, idx) => (
					<ImmobilieKaufenHomeObject key={idx} offer={offer}/>
				))}
                {/* {JSON.stringify(offers.items)} */}
			</div>
		</div>
	);
}

interface ImmobilieKaufenHomeObjectProps {
	offer: ImmobilieKaufenHomeInterface;
}

const ImmobilieKaufenHomeObject = (props: ImmobilieKaufenHomeObjectProps) => {
	const {offer} = props;

	if (!offer) return <></>;
	return (
		<div
			key={"wrapper-" + offer.id}
			className="snap-center flex-1 sm:flex-none md:snap-none w-[225px] sm:w-[400px] xl:w-[calc(33.33%-28px)] rounded-[20px] shadow-[0px_1px_6px_rgba(0,0,0,0.1607843137)] m-1"
		>
			<ImmoCardHome
				minimalMobileVersion={true}
				key={offer["id"]}
				object={offer}
				isLastMinuteCard={true}
				sale={true}
			/>
		</div>
	);
};
